module.exports = "/dist/arrow.down.png?803a8019f2fc0fb968e077b26623f95b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.down.png
// module id = 97
// module chunks = 0